/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { dropTask, Task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';

interface CredentialsConfigGistArgs {
  organizationId: string;
  configureGistTask: Task<unknown, [string, string]>;
  disableGistTask: Task<void, []>;
}

export default class CredentialsConfigGist extends Component<CredentialsConfigGistArgs> {
  @tracked username = '';
  @tracked password = '';

  constructor(owner: unknown, args: CredentialsConfigGistArgs) {
    super(owner, args);
    this.username = args.organizationId ?? '';
  }

  createOrUpdateCredential = dropTask(async (evt?: Event) => {
    evt?.preventDefault();
    await this.args.configureGistTask.perform(this.username, this.password);
    this.clearPassword();
  });

  disableCredential = dropTask(async () => {
    await this.args.disableGistTask.perform();
  });

  private clearPassword() {
    this.password = '';
  }
}
